import React from 'react';

interface Props {
  message: string;
}

export default function BankrollMessage({ message }: Props) {
  const lines = message.split('\n');
  return (
    <>
      {lines.map((line, index) => (
        <span key={`${index}_${line}`}>
          {line}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </>
  );
}
